import React, { useContext, useEffect, useState } from 'react'
import Select from '../../../components/Common/Input/Select';
import Cards from './Cards'
import Tables from './Tables'
import excel from '../../../assets/excel.png'
import graph from '../../../assets/graph.png'
import { objectsForEach } from '../../../common/objectToArray';
import MasterDataService from '../../../services/master-data';
import { Context } from '../../../config/store';
import TotalCount from './TotalCount';
import { downloadFile } from '../../../common/download';
import { toast } from 'react-toastify';
import './Dashboard.css'
import DatePicker from 'react-datepicker';
import { getFormattedDate } from '../../../common/date';
import { Button } from 'bootstrap';

const NewDashboard = () => {
  const { state, dispatch } = useContext(Context);
  const [activeTab, setActiveTab] = useState('lender')
  const [activePath, setActivePath] = useState('lender-portfolio')
  const [selectedMonths, setSelectedMonths] = useState('')
  const [selectedlenderData, setSelectedlenderData] = useState('')
  const [selectedprograam, setSelectedprograam] = useState('')
  const [defaultProgram, setDefaultProgram] = useState([])
  const [defaultLender, setDefaultLender] = useState([])
  const [selectedyear, setSelectedyear] = useState('')
  const [showCrossIcon, setShowCrossIcon] = useState(false)
  const [productNames, setProducts] = useState([]);
  const [lenders, setLenders] = useState([]);
  const [portfolio, setportfolio] = useState([])
  const [total, setTotal] = useState()
  const [tableData, setTableData] = useState()
  const [loading, setLoading] = useState(false)
  const [assignDateFrom, setAssignDateFrom] = React.useState('');
  const [assignDateTo, setAssignDateTo] = React.useState('');
  const [leadType, setLeadType] = React.useState(null);
  const [exportloader, setExportloader] = useState(false)
  React.useEffect(() => {
    dispatch({
      type: 'selectedColender',
      selectedColender: '/portfolio/dashboard',
    });
    localStorage.setItem('selectedColender', '/portfolio/dashboard');
  }, []);

  const portfoliodetail = async () => {
    setLoading(true)
    const response = await MasterDataService.getportfoliodetail(
      state.userType,
      state.userType === 'admin' ? 'co-lender' : ''
    );
    // console.log(response)
    if (response?.data?.status?.code === 1) {
      setportfolio(response?.data?.data?.portfolio)
    }
  };
  const productList = async () => {
    const response = await MasterDataService.getProductTypeList(
      state.userType,
      state.userType === 'admin' ? 'co-lender' : ''
    );
    if (response?.data?.status?.code === 1) {
      setLoading(false)
      let responseList = objectsForEach(
        response.data.data.product_category,
        'STRING_VAL'
      );
      let products = responseList.map((response) => ({
        label: response.value,
        value: response.id,
      }));
      setProducts(products);
    }
  };
  const lenderList = async () => {
    const response = await MasterDataService.getLenderList(
      state.userType,
      state.userType === 'admin' ? 'co-lender' : ''
    );
    if (response?.data?.status?.code === 1) {
      let responseList = objectsForEach(
        response.data.data.lender_list,
        'STRING_VAL'
      );
      let lenderItems = responseList.map((response) => ({
        label: response.value,
        value: response.id,
      }));
      setLenders(lenderItems);
    }
  };

  useEffect(() => {
    productList();
    lenderList();
    portfoliodetail()
  }, []);

  useEffect(() => {
    if ((assignDateFrom && assignDateTo) || (!assignDateFrom && !assignDateTo)) {
      getTableData(activeTab, activePath)
    }
  }, [selectedMonths, activeTab, activePath, selectedlenderData, selectedyear, selectedprograam, leadType, assignDateFrom, assignDateTo])

  const getTableData = async (activeStatus, path) => {
    let toDate = assignDateTo ? getFormattedDate(assignDateTo, 'dd/MM/yyyy') : ''
    let fromDate = assignDateFrom ? getFormattedDate(assignDateFrom, 'dd/MM/yyyy') : ''
    setLoading(true)
    setActiveTab(activeStatus)
    const response = await MasterDataService.getTableData(
      state.userType,
      state.userType === 'admin' ? 'co-lender' : '',
      path,
      selectedMonths,
      selectedlenderData,
      selectedprograam,
      selectedyear,
      leadType?.value ?? '',
      fromDate,
      toDate
    );

    if (response?.data?.status?.code === 1) {
      setLoading(false)
      if (activeStatus === "lender") {
        let TableDataGet = objectsForEach(response?.data?.data?.lender_portfolio)
        let filterData = TableDataGet.filter(TableDataGet => TableDataGet?.lead_assigned != 0)
        setTableData(filterData)
        setTotal(response?.data?.data?.total)
      }
      if (activeStatus === "program") {
        let TableDataGet = objectsForEach(response?.data?.data?.program_portfolio)
        setTableData(TableDataGet)
        setTotal(response?.data?.data?.total)
      } if (activeStatus === "co_lending") {
        let TableDataGet = objectsForEach(response?.data?.data?.lendingtype_portfolio)
        setTableData(TableDataGet)
        setTotal(response?.data?.data?.total)
      }

    }
  }
  const getexcelTableData = async (activeStatus, path, exportExcel) => {
    setExportloader(true)
    let toDate = assignDateTo ? getFormattedDate(assignDateTo, 'dd/MM/yyyy') : ''
    let fromDate = assignDateFrom ? getFormattedDate(assignDateFrom, 'dd/MM/yyyy') : ''
    const response = await MasterDataService.getexcelTableData(
      state.userType,
      state.userType === 'admin' ? 'co-lender' : '',
      path,
      selectedMonths,
      selectedlenderData,
      selectedprograam,
      selectedyear,
      leadType?.value ?? '',
      fromDate,
      toDate,
      exportExcel
    );
    // console.log(response)
    if (response?.status === 200) {
      downloadFile(response.data, `${activeStatus}-${(new Date()).toLocaleDateString('en-GB').split('/').join('-')}`);
      setExportloader(false)
    } else {
      setExportloader(false)
      toast.warning('downloaded faild')
    }
  }

  const handleLenderData = (data) => {
    let months = '';
    let lenderItem = [];
    let max = data?.length;
    data?.map((mon, index) => {
      if (index === max - 1) {
        months += mon.value
        lenderItem.push(mon)
      } else {
        months += `${mon.value},`
        lenderItem.push(mon)
      }
    })
    setSelectedlenderData(months)
    setDefaultLender(lenderItem)
  }

  return (
    <>
      <div className='container subHeaderbar'>
        Dashboard
      </div>
      <Cards portfolio={portfolio} />
      <div style={{ padding: "5px 10px", backgroundColor: "#FFFF", borderRadius: "10px", marginTop: "0px", margin: '0px 8px', }}>
        <div >
          {/* <div className='TabsContainer'>
            <div className='tab-item' onClick={() => {
              setActiveTab('lender')
              setActivePath('lender-portfolio')
            }}>
              <p className={activeTab === 'lender' ? 'activetab' : ''}>
                LENDER
              </p>
            </div>
            <div className='tab-item' onClick={() => {
              setActiveTab('program')
              setActivePath('program-portfolio')
            }}>
              <p className={activeTab === 'program' ? 'activetab' : ''}>
                PROGRAM
              </p>
            </div>
            <div className='tab-item border-right-none' onClick={() => {
              setActiveTab('co_lending')
              setActivePath('lendingtype-portfolio')
            }}>
              <p className={activeTab === 'co_lending' ? 'activetab' : ''}>
                CO-LENDING TYPE
              </p>
            </div>
          </div> */}
          <div className="filter_main_container mt-2">
            <div className="filter_view_container">
              <div className='filter_view_item form_input'>
                <Select
                  label='Lenders'
                  options={lenders}
                  className={'dropdown'}
                  onChange={(data) => handleLenderData(data)}
                  defaultValue={defaultLender}
                />
              </div>
              <div className='filter_view_item form_input' style={{ width: '120px' }}>
                <div className='form-group'>
                  <Select
                    isMulti={false}
                    label='CLM Type'
                    options={[
                      { label: 'All', value: '' },
                      { label: 'Option 1', value: 1 },
                      { label: 'Option 2', value: 2 },
                    ]}
                    value={leadType}
                    onChange={(data) => setLeadType(data)}
                  />
                </div>
              </div>
              <div className='col-md-6 filter_view_item form_input' >
                <div className='form-group'>
                  <label>Assigned Date </label>
                  <div className='d-flex justify-content-between'>
                    <div className='d-flex w-50 align-items-center'>
                      <span className='mr-2'>From</span>
                      <DatePicker
                        selected={assignDateFrom}
                        portalId='datepickerportal'
                        showMonthDropdown
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        className='form-control'
                        dateFormat='dd/MM/yyyy'
                        isClearable={assignDateFrom ? true : false}
                        onChange={(selectedDate) =>
                          setAssignDateFrom(selectedDate)
                        } //only when value has changed
                      />
                    </div>

                    <div className='d-flex w-50 align-items-center'>
                      <span className='ml-2 mr-2'>To</span>
                      <DatePicker
                        selected={assignDateTo}
                        portalId='datepickerportal'
                        showMonthDropdown
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        className='form-control'
                        dateFormat='dd/MM/yyyy'
                        isClearable={assignDateTo ? true : false}
                        onChange={(selectedDate) =>
                          setAssignDateTo(selectedDate)
                        } //only when value has changed
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='filter_right'>
              {/* {exportloader ? <div className='TableLoader' style={{height:"40px",width:"40px"}}></div> : <img src={excel} alt="excel" className='iconItem' onClick={() => getexcelTableData(activeTab, activePath, 1)} />} */}
              <button
                type='submit'
                className='btn btn-custom ml-2'
                onClick={() => getexcelTableData(activeTab, activePath, 1)}
              >
                {exportloader ? <div className='loader' /> : <> <i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>Export Excel </>}
              </button>
            </div>
          </div>
          {loading ? <div className='loader' style={{ margin: "10% auto  auto auto" }}></div> : <>
            <div style={{ minHeight: 140 }}>
              {tableData?.length > 0 ? <Tables activeTab={activeTab} tableData={tableData} /> : <div style={{ margin: "8% auto  auto 35%", fontWeight: 600, fontSize: 18 }}>This Lender has no Case assigned</div>}
            </div>
          </>}

        </div>
        {/* <div className='relative-bottom' > */}
        {tableData?.length > 0 && <TotalCount activeTab={activeTab} total={total} />}
        {/* </div> */}
      </div>
    </>
  )
}

export default NewDashboard